import React, { useMemo } from 'react';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import content, { useContent } from '../../../../redux/reducer/content';
import { useDispatch } from 'react-redux';

const Volume = React.forwardRef(function Volume({ className, icons, text }, ref) {
  const { isSound } = useContent();
  const dispatch = useDispatch();
  const buttonIcon = useMemo(() => icons[isSound ? 'on' : 'off'], [icons, isSound]);
  const buttonText = useMemo(() => text[isSound ? 'on' : 'off'], [isSound, text]);
  return (
    <CustomButton
      className={classNames('volume button_volume button_transparent', className, {
        volume_active: isSound,
      })}
      icon={buttonIcon}
      text={buttonText}
      onClick={(e) => {
        e.stopPropagation();
        dispatch(content.actions.setIsSound(!isSound));
        //onToggle("main");
      }}
      ref={ref}
    />
  );
});
export default Volume;
Volume.propTypes = {};
